import axios from 'axios';

/**
 * Check if the stored token is expired
 * @returns {boolean} True if token is expired or not found
 */
export const isTokenExpired = () => {
  const expiresAt = localStorage.getItem('tokenExpiresAt');
  
  if (!expiresAt) {
    return true; // If we don't have expiration time, consider token expired
  }
  
  // Compare current time with expiration time
  return Date.now() >= parseInt(expiresAt);
};

/**
 * Clear all authentication data from localStorage
 */
export const clearAuthData = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('dToken');
  localStorage.removeItem('authToken');
  localStorage.removeItem('user');
  localStorage.removeItem('userRole');
  localStorage.removeItem('isAuthenticated');
  localStorage.removeItem('tokenExpiresAt');
  
  // Clear all cached permissions (pattern: permissions:<userId>)
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith('permissions:')) {
      localStorage.removeItem(key);
    }
  });
};

/**
 * Set up axios interceptor to handle authentication
 * @param {Function} logoutCallback Function to call when token is invalid/expired
 */
export const setupAuthInterceptor = (logoutCallback) => {
  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token');
      
      // Check for token expiration before making requests
      if (token && !isTokenExpired()) {
        // Add token to request headers
        config.headers.Authorization = `Bearer ${token}`;
      } else if (token && isTokenExpired()) {
        // Token exists but is expired
        clearAuthData();
        logoutCallback();
      }
      
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  
  // Response interceptor to handle 401 errors
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        // Unauthorized error, clear auth data and log out
        clearAuthData();
        logoutCallback();
      }
      return Promise.reject(error);
    }
  );
};
